module.exports = __webpack_public_path__ + "img/VMaria_2.dd26a094.jpg";